import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output
} from '@angular/core';

const RISK_LABEL_CRITICAL = 'Critical';
const RISK_NOT_DETECTED = 'Not Detected';

const RISK_CRITICAL = 'critical';
const NOT_DETECTED = 'not-detected';

@Component({
  selector: 'violation-risk',
  templateUrl: './violation-risk.html',
  styleUrls: ['./violation-risk.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViolationRiskComponent {
  @Input() risk: string = '';
  @Input() label: string = '';

  @Output() interact: EventEmitter<Event> = new EventEmitter<Event>();

  get riskNormalized(): string {
    if (this.label) return this.label;
    if (!this.risk || typeof this.risk !== 'string') return NOT_DETECTED;

    let r = this.risk.toLowerCase();

    if (r === 'critical' || r === 'c') {
      return RISK_CRITICAL;
    }

    return NOT_DETECTED;
  }

  get riskLabel(): string {
    if (this.label) return this.label;
    if (!this.risk || typeof this.risk !== 'string') return RISK_NOT_DETECTED;

    let r = this.risk.toLowerCase();

    if (r === 'critical' || r === 'c') {
      return RISK_LABEL_CRITICAL;
    }

    return RISK_NOT_DETECTED;
  }

  constructor() {}

  @HostListener('click', ['$event'])
  onClick(event: Event) {
    this.interact.emit(event);
  }
}
